const list = ['LF10', 'LF52', 'LF85', 'LP82', 'OG25', 'OP37', 'OR73', 'OS46', 'OW44', 'PR07', 'X918'];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}